module.exports = __webpack_public_path__ + "static/media/tablet3.b13d9f4c.png";